import React from "react";
import { Grid } from "@material-ui/core";

import { localizer } from "../../../Translator";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Backdrop, CircularProgress } from "@material-ui/core"
import Timeline from '@material-ui/lab/Timeline'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import { Typography } from "@material-ui/core"
import Chip from '@material-ui/core/Chip'
import Paper from "@material-ui/core/Paper";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { TimelineItemStyled } from "../../common/TimelineStyled"

import DateCustom from "../../Utilities/DateCustom"
import Roles from "../../Utilities/Roles"
import StateCodes from "../../Utilities/StateCodes.js"

import AuthCli from "../../../sdk/AuthCli";
import InboxCli from "../../../sdk/InboxCli";
import OutboxCli from "../../../sdk/OutboxCli";
import ProductCli from "../../../sdk/ProductCli";

export class FeedbackShipmentSummary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,

      // Shipment object which feedback belong to
      shipment: {},
      shipmentId: null,

      // List of products availables for the user in session
      products: [],

      // Concatenation of the names of the draft documents that make up the final document of the shipment
      documentNames: [],
      shipmentFeedbacks: [],

      // String errors to display in case of service calls go wrong
      feedbackShipmentError: null,
      feedbackShipmentDraftError: null,
      feedbackShipmentStatestError: null,
      downloadShipmentDocumentError: null,
      errormessage: null,

      // Number of the current page which is displaying
      currentPage: 1,
      documentpages: [],

      // Base64 string that represent the content of draft document
      pageBase64: "",

      // String errors to display in case of service calls go wrong
      pageBase64Error: null,

      states: [],
      certs: [],
      proofs: [],
      reports: [],
      documents: [],
      stampedCopies: [],

      // Value of the price with format 
      priceFormat: ""

    }
  }

  /**
   * Component initialization. Filling state with the shipment and its associate information (drafts, feedbacks, etc)
   */
  componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          this.getAllProducts()

          if (this.state.session.role === Roles.ROLE_USER.Name) {
            this.getShipmentByCode(this.props.shipmentCode)
            return
          }

          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getShipmentByCodeOfBillable(this.props.shipmentCode)
            return
          }
        })
      }
    })
  }

  // Getting list of product to visualize product description instead of productCode
  getAllProducts = () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  getShipmentByCode = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCode(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })

            this.getDocumentsOfShipment()
            this.getFeedbacksOfShipment()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  getShipmentByCodeOfBillable = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCodeOfBillable(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })

            this.getDocumentsOfShipmentOfBillable()
            this.getFeedbacksOfShipment()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }


  /**
   * Get documents and pages information to display the preview in the shipment summary for role USER
   */
  getDocumentsOfShipment = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraft(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }

  /**
   * Get documents and pages information to display the preview in the shipment summary for role ADMIN
   */
  getDocumentsOfShipmentOfBillable = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraftOfBillable(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }

  /**
   * Gets feedbacks information of the shipment given
   */
  getFeedbacksOfShipment = () => {
    InboxCli.GetFeedbackOfShipment(this.state.shipment.shipmentCode, true, true, true, true, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ feedbackShipmentStatestError: null, shipmentFeedbacks: data },
          () => {
            this.getStatesInfo()
            this.getCertsInfo()
            this.getProofsInfo()
            this.getDocuments()
            this.getStampedCopies()
          })
      }
    })
  }

  /**
   * Gets states information of shipment to display it in the summary
   */
  getStatesInfo = () => {
    var returnsId = this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STATE).map(f => f.returnId)

    InboxCli.GetStates(returnsId).then(statesresponse => {
      if (statesresponse !== null && statesresponse.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: statesresponse.substring(statesresponse.indexOf(' ')) })
      } else {
        statesresponse = statesresponse.map(st => {
          var temp
          if (st !== null) {
            temp = Object.assign({}, st)
            temp.stateData = JSON.parse(st.stateData)
          }
          return temp
        })
        let statesFiltered = statesresponse.filter(d => d !== null && d.stage !== InboxCli.RETURN_STAGE_RETURN)
        if (statesFiltered) statesFiltered.sort(this.sortByDate("timestamp"))
        
        statesFiltered = this.groupStatesByTracking(statesFiltered)
        this.setState({ states: statesFiltered })
      }
    })
  }

  /**
  * Gets certs information of shipment to display it in the summary
  */
  getCertsInfo = () => {
    var returnsId = this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_CERT).map(f => f.returnId)

    InboxCli.GetCerts(returnsId).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: data.substring(data.indexOf(' ')) })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ certs: filtered, feedbackShipmentStatestError: null })
      }
    })
  }

  /**
   * Gets proofs information of shipment to display
   */
  getProofsInfo = () => {
    InboxCli.GetProofs(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_PROOF).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ proofs: filtered, message: null })
      }
    })
  }

  /**
   * Gets documents information of shipment to display
   */
  getDocuments = () => {
    InboxCli.GetDocuments(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_DOCUMENT).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ documents: filtered, message: null })
      }
    })
  }

  /**
   * Gets stamped copies information of shipment to display
   */
  getStampedCopies = () => {
    InboxCli.GetStampedCopy(this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STAMPED_COPY).map(f => f.returnId)).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ stampedCopies: filtered, message: null })
      }
    })
  }

  groupStatesByTracking = (states) => {
    let originalTracking = this.state.shipment && this.state.shipment.dequeuedTime ? (this.props.trackingMain && this.props.trackingMain.codeValue) ? this.props.trackingMain.codeValue.toUpperCase() : "N/A" : "N/A"
    let groupedStates = []

    states.forEach(state => {
      let tracking = state.stateData.Tracking && state.stateData.Tracking.toUpperCase()
      if (!tracking) tracking = originalTracking
      
      let stateList = groupedStates[tracking]
      if (!stateList) {
        groupedStates[tracking] = [state]
      } else {
        groupedStates[tracking].push(state)
      }
    })
    
    return groupedStates
  }

  downloadDocument = () => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadShipmentDocument()
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadShipmentDocumentOfBillable()
      return
    }
  }

  downloadShipmentDocument = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocument(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ downloadShipmentDocumentError: error.substring(error.indexOf(' ')) })
      else this.setState({ downloadShipmentDocumentError: null })
      this.setState({ isLoading: false })
    })
  }

  downloadShipmentDocumentOfBillable = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocumentOfBillable(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ downloadShipmentDocumentError: error.substring(error.indexOf(' ')) })
      else this.setState({ downloadShipmentDocumentError: null })
      this.setState({ isLoading: false })
    })
  }

  /**
   * download the file associated to feedback
  */
  downloadFeedbackFile = (event) => {
    let returnId = event.currentTarget.getAttribute('name')
    if (!returnId) return

    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackFile(returnId).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""

    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountSenderAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.senderAddress) return ""

    let senderAddress = ""

    senderAddress = this.state.shipment.senderAddress.who + "\n" +
      this.state.shipment.senderAddress.streetType + " " + this.state.shipment.senderAddress.streetName + " " + this.state.shipment.senderAddress.streetNumber + "\n" +
      this.state.shipment.senderAddress.postalCode + " " + this.state.shipment.senderAddress.locality
    return senderAddress
  }

  getProductDescription = () => {
    let description = ""
    this.state.products && this.state.shipment.features && this.state.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /**
   * get url to logistic operator
   */
  getUrlOperator = (tracking) => {
    if (!tracking) return ''
    let codTracking = tracking.codeValue
    let initTracking = codTracking && codTracking.slice(0, 2);
    
    let products = ["PQ", "PK", "NB", "CD", ...ProductCli.SIDI_PRODUCT_CODE];
    const url = products.includes(initTracking) ?
      'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=' + codTracking : ''
    return url
  }

  bytesToBestMagnitude = (len) => {
    let sizes = ["B", "KB", "MB", "GB", "TB"]
    let order = 0;
    while (len >= 1024 && order < sizes.length - 1) {
      order++;
      len = len / 1024;
    }

    let newLen = (Math.round(len * 100) / 100).toFixed(1) + " " + sizes[order]
    return newLen
  }

  /**
   * sort json by date by atribute asc
   */
  sortByDate(prop) {
    return function (a, b) {
      if (a && b) {
        var a2 = Date.parse(a[prop].substring(0, 23) + a[prop].substring(26));
        var b2 = Date.parse(b[prop].substring(0, 23) + b[prop].substring(26));
        return new Date(a2).getTime() - new Date(b2).getTime()
      }
    }
  }

  render() {
    let url = this.getUrlOperator(this.props.trackingMain)
    const reference = this.state.shipment.features && this.state.shipment.features.reference ? this.state.shipment.features.reference.toUpperCase() : ""
    const shipmentCode = this.state.shipment.shipmentCode
    const ownerUser = this.state.shipment ? this.state.shipment.ownerUser : ""
    const billableCode = this.state.session ? this.state.session.realm : ""
    
    let tracking = this.state.shipment && this.state.shipment.dequeuedTime ? this.props.trackingMain ? this.props.trackingMain.codeValue : "N/A" : "N/A"
    let labelEmissionTime = this.state.shipment ? (this.state.shipment.emissionTime !== null && new Date(this.state.shipment.emissionTime) > Date.now()) ? localizer.InboxDateProgrammed : localizer.InboxDateEmission : null

    const isLastState = this.state.states && Object.keys(this.state.states).length > 0 && this.state.states[tracking] && this.state.states[tracking].length > 0
    const batchLabel = this.state.shipment && this.state.shipment.batchLabel ? this.state.shipment.batchLabel : null
    //let showCancelResquested = this.state.shipment && this.state.shipment.cancelRequestedTime && !isFinalState ? true : false
    
    return (
      <React.Fragment>
        <Dialog
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"xl"}
        >
          <DialogTitle id="alert-dialog-title" className="bg-primary" style={{ color: "black" }}>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.props.handleCloseModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.InboxShipmentDetails}</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container direction="row" justify="center" className="mt-20 mb-20">

              <Grid container item md={12} direction="row">
                <Grid container item md={4}>
                  <Paper elevation={3} style={{ width: "100%" }} className="mr-15 p-10">
                    <Typography className="typography-generic">{localizer.InboxShipmentCode + " : "}</Typography>
                    <Typography className="typography-generic bigweight ml-25">{shipmentCode}</Typography>
                    <Typography className="typography-generic">{localizer.Reference + " : "}</Typography>
                    <Typography className="typography-generic bigweight ml-25">{reference}</Typography>
                  </Paper>
                </Grid>
                <Grid container item md={4}>
                  <Paper elevation={3} style={{ width: "100%" }} className="p-10">
                    <Typography className="typography-generic">{localizer.Tracking + " : "}</Typography>
                    <Typography className="typography-generic bigweight ml-25">{tracking}</Typography>
                  </Paper>
                </Grid>
                <Grid container item md={4}>
                  <Paper elevation={3} style={{ width: "100%" }} className="ml-15 p-10">
                    <Typography className="typography-generic">{localizer.User + " : "}</Typography>
                    <Typography className="typography-generic bigweight ml-25">{ownerUser}</Typography>
                    <Typography className="typography-generic">{localizer.Billable + " : "}</Typography>
                    <Typography className="typography-generic bigweight ml-25">{billableCode}</Typography>
                  </Paper>
                </Grid>
              </Grid>

              {/*  Chronology section */}
              <Grid item md={4} className="mt-15">
                <Paper elevation={3} style={{ minHeight: '400px' }} className="mr-15">
                  <Grid container item md={12} className="p-15">
                    <Grid item md={12}>
                      <Typography className="typography-generic medium bigweight secondary"><i className="fa-solid fa-clock secondary"></i> {localizer.InboxChronology}</Typography>
                      <hr className="hr-custom"></hr>
                    </Grid>
                    <Grid item md={12}>
                      <Timeline className="p-0">
                        {this.state.shipment &&
                          <TimelineItemStyled style={{ minHeight: "55px" }}>
                            <TimelineSeparator>
                              <TimelineDot className={isLastState ? "bg-info" : "bg-primary dot-animation"} />
                              <TimelineConnector className={isLastState ? "bg-info" : "custom-timeline-dooted"} />
                            </TimelineSeparator>
                            <TimelineContent className="pt-0">
                              <Grid container item md={12}>
                                <Grid item md={12}><Typography className="typography-generic pt-3"><strong>{labelEmissionTime}</strong>{" - " + DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid>
                                {/* <Grid item md={12}><Typography className="typography-generic small">{localizer.Date}: {DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid> */}
                              </Grid>
                            </TimelineContent>
                          </TimelineItemStyled>
                        }
                        {this.state.states && Object.keys(this.state.states).map((state, index) => {
                          let statetracking = state
                          let statelist = this.state.states[state]
                          
                          return (
                            <Accordion className="mt-5 mb-5">
                              <AccordionSummary style={{ height: "40px", minHeight: "unset" }} expandIcon={<ExpandMoreIcon />} aria-controls={state + "-content"} id={state + "-content"}>
                                <Typography className="typography-generic bigweight">{statetracking}</Typography>
                              </AccordionSummary>
                              <AccordionDetails style={{ display: "inherit" }}>
                                {statelist.map((stateinfo, index) => {
                                  let stateCode = StateCodes.CODES.find(c => c.stateCode === stateinfo.stateCode)
                                  let stateName = stateCode ? stateCode.name : null
                                  let statusCodeEnd = stateCode ? stateCode.end : false

                                  return (
                                    <TimelineItemStyled key={stateinfo.returnId + "-" + index}>
                                      {!statusCodeEnd ?
                                        < TimelineSeparator >
                                          <TimelineDot className={(index !== statelist.length - 1) ? "bg-info" : "bg-primary dot-animation"} />
                                          <TimelineConnector className={(index !== statelist.length - 1) ? "bg-info" : "custom-timeline-dooted"} />
                                        </TimelineSeparator>
                                        :
                                        < TimelineSeparator >
                                          <TimelineDot className="bg-info" />
                                        </TimelineSeparator>
                                      }
                                      <TimelineContent className="pt-0">
                                        <Grid container item md={12} className={stateinfo.stateCode === "EPD" || stateinfo.stateCode === "EPR" ? "bg-electronic-proof" : ""}>
                                          <Grid item md={12}>
                                            <Typography className="typography-generic pt-3"><strong>{stateName}</strong> {" - " + DateCustom.convertUTCToLocalTime(stateinfo.timestamp)}</Typography>
                                            <Typography className="typography-generic small"> {stateinfo.stateData.Details ? stateinfo.stateData.Description + " - " + stateinfo.stateData.Details : stateinfo.stateData.Description}</Typography>
                                          </Grid>
                                          {stateinfo.stateData.Office &&
                                            <Grid container item md={12}>
                                              {/* <Grid item md={5}><Typography className="typography-generic small">{localizer.Date}: {DateCustom.convertUTCToLocalTime(stateinfo.timestamp)}</Typography></Grid> */}
                                              {/* <Grid item md={12}> */}
                                              <Typography className="typography-generic small display-inline-flex">{localizer.Office + ":" + stateinfo.stateData.Office}</Typography>
                                              {/* </Grid> */}
                                            </Grid>
                                          }
                                        </Grid>
                                      </TimelineContent>
                                    </TimelineItemStyled>
                                  )
                                })
                                }
                              </AccordionDetails>
                            </Accordion>
                          )
                        })}
                      </Timeline>
 
                      {this.state.shipment && this.state.shipment.cancelTime &&
                        <TimelineItemStyled style={{ minHeight: "55px" }}>
                          <TimelineSeparator>
                            <TimelineDot className={"bg-info"} />
                          </TimelineSeparator>
                          <TimelineContent className="pt-0">
                            <Grid container item md={12}>
                              <Grid item md={12}><Typography className="typography-generic pt-3"><strong>{localizer.InboxStateCAN}</strong>{" - " + DateCustom.convertUTCToLocalTime(this.state.shipment.cancelTime)}</Typography></Grid>
                              {/* <Grid item md={12}><Typography className="typography-generic small">{localizer.Date}: {DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid> */}
                            </Grid>
                          </TimelineContent>
                        </TimelineItemStyled>
                      }
                      {this.state.shipment && this.state.shipment.cancelRequestedTime &&
                        <Grid item md={12} >
                          <Grid item md={12}><Typography className="typography-generic pt-3"><strong>{localizer.InboxStateCNR}</strong>{" - " + DateCustom.convertUTCToLocalTime(this.state.shipment.cancelRequestedTime)}</Typography></Grid>
                        </Grid>
                      }
                    </Grid>

                    {this.props.trackingMain &&
                      <Grid container item md={12}>
                        <Grid item md={12} >
                          <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: </Typography>
                        </Grid>
                        <Grid container item md={12}>
                          <Grid item md={6}><Typography className="typography-generic pb-0 pt-0">{DateCustom.convertUTCToLocalTime(this.props.trackingMain.assignedTime)}</Typography></Grid>
                          <Grid item md={6}><Typography className="typography-generic bigweight  pb-0 pt-0"><a className="link-hover" href={url} target="_blank" rel="noreferrer">{this.props.trackingMain.codeValue}</a></Typography></Grid>
                        </Grid>
                      </Grid>

                    }
                    {this.props.trackingsDispatches && this.props.trackingsDispatches.length !== 0 &&
                      <Grid container item md={12}>
                        <Grid item md={12}>
                          <Typography className="typography-generic bigweight secondary"> {localizer.ReDispatches}: </Typography>
                          <hr className="hr-custom" />
                        </Grid>
                        {this.props.trackingsDispatches.map(t => {
                          let url = this.getUrlOperator(t)
                          return (
                            <Grid container item md={12}>
                              <Grid item md={6}><Typography className="typography-generic">{DateCustom.convertUTCToLocalTime(t.assignedTime)}</Typography></Grid>
                              <Grid item md={6}><Typography className="typography-generic bigweight"><a className="link-hover" href={url} target="_blank" rel="noreferrer">{t.codeValue}</a></Typography></Grid>
                            </Grid>
                          )
                        })
                        }
                      </Grid>
                    }
                  </Grid>
                </Paper>
              </Grid>

              {/*  Shipment info section */}
              <Grid item md={4} className="mt-15">
                <Paper elevation={3} style={{ minHeight: '400px' }}>
                  <Grid container item md={12} className="p-15">
                    <Grid item md={12}>
                      <Typography className="typography-generic medium bigweight secondary">
                        <i className="fa-solid fa-circle-info secondary mr-5"></i>
                        {localizer.InboxShipmentInfo}
                      </Typography>
                      <hr className="hr-custom"></hr>
                    </Grid>

                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic">{this.getProductDescription()}</Typography></Grid>
                    
                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.ShipmentSummaryBatch}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic">{batchLabel}</Typography></Grid>
                                           
                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxIncludedPages}:</Typography></Grid>
                    <Grid item md={6}>
                      {this.state.documentNames && this.state.documentNames.map((doc, index) => {
                        return (<Typography key={"docname-" + index} className="typography-generic shipment-summary-docnames">{doc}</Typography>)
                      })}
                    </Grid>

                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxSender}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic white-space-pre" style={{ overflowX: "auto" }}>{this.mountSenderAddress()}</Typography></Grid>

                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxDestination}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic white-space-pre" style={{ overflowX: "auto" }}>{this.mountDestinationAddress()}</Typography></Grid>
                    
                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.NotifyToThirdParty}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic white-space-pre" style={{ overflowX: "auto" }}> {this.state.shipment.features && this.state.shipment.features.notifyToThirdParty}</Typography></Grid>
                   
                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxPrintFeatures}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic">{this.state.shipment.features ? (this.state.shipment.features.printColor ? "Color" : "B/N") + ", " + (this.state.shipment.features.printDuplex ? localizer.InboxDuplex : localizer.InboxSimplex) : ""}</Typography></Grid>

                    <Grid item md={6}><Typography className="typography-generic bigweight">{localizer.InboxPrice}:</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic">{this.state.priceFormat}</Typography></Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/*  Shipment documents section */}
              <Grid item md={4} className="mt-15">
                <Paper elevation={3} style={{ minHeight: '400px' }} className="ml-15">
                  <Grid container item md={12} className="p-15">
                    <Grid item md={12}>
                      <Typography className="typography-generic medium bigweight secondary"><i className="fa-solid fa-file-lines secondary"></i> {localizer.InboxDocuments}</Typography>
                      <hr className="hr-custom"></hr>
                    </Grid>

                    <Grid container item md={12}>
                      <Grid item md={12} className="pt-0 pb-0">
                        <Typography className="typography-generic bigweight link-hover" onClick={this.downloadDocument}>{localizer.InboxDocumentOriginal}</Typography>
                      </Grid>
                      <Grid container item md={12} className="pt-0 pb-0">
                        <Grid item md={8}>
                          <Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography>
                        </Grid>
                        <Grid item md={4}>
                          <Chip className="document-tag float-right" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                        </Grid>
                      </Grid>
                    </Grid>

                    {this.state.documents && this.state.documents.map((document, index) => {
                      let size = document !== null ? this.bytesToBestMagnitude(document.documentSize) : 0
                      return (
                        <Grid container item md={12} key={"document-" + index}>
                          <Grid item md={12} className="pt-0 pb-0">
                            <Typography name={document.returnId} className="typography-generic bigweight link-hover" onClick={this.downloadFeedbackFile}>{document.documentFileName}</Typography>
                          </Grid>
                          <Grid container item md={12} className="pt-0 pb-0">
                            <Grid item md={8}>
                              <Typography className="typography-generic small"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(document.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size}</Typography>
                            </Grid>
                            <Grid item md={4}>
                              <Chip className="document-tag float-right" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} name={document.returnId} />
                            </Grid>
                            
                          </Grid>
                        </Grid>
                      )
                    })}

                    {this.state.stampedCopies && this.state.stampedCopies.map((stampedCopy, index) => {
                      let size = stampedCopy !== null ? this.bytesToBestMagnitude(stampedCopy.documentSize) : 0
                      return (
                        <Grid container item md={12} key={"stamped-copy-" + index}>
                          <Grid item md={12} className="pt-0 pb-0">
                            <Typography className="typography-generic bigweight link-hover" name={stampedCopy.returnId} onClick={this.downloadFeedbackFile}>{stampedCopy.documentFileName}</Typography>
                          </Grid>
                          <Grid container item md={12} className="pt-0 pb-0">
                            <Grid item md={8}>
                              <Typography className="typography-generic small"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(stampedCopy.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size}</Typography>
                            </Grid>
                            <Grid item md={4}>
                              <Chip className="document-tag float-right" icon={<i className="fa-solid fa-stamp font-size-12 color-document-icon" />} label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxStampedCopy}</Typography>} name={stampedCopy.returnId} />
                            </Grid>

                          </Grid>
                        </Grid>
                      )
                    })}

                    {this.state.proofs && this.state.proofs.map((proof, index) => {
                      let size = proof !== null ? this.bytesToBestMagnitude(proof.documentSize) : 0
                      return (
                        <Grid container item md={12} key={"proof-" + index}>
                          <Grid item md={12} className="pt-0 pb-0">
                            <Typography className="typography-generic bigweight link-hover" name={proof.returnId} onClick={this.downloadFeedbackFile}>{proof.documentFileName}</Typography>
                          </Grid>
                          <Grid container item md={12} className="pt-0 pb-0">
                            <Grid item md={8}>
                              <Typography className="typography-generic small"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(proof.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size}</Typography>
                            </Grid>
                            <Grid item md={4}>
                              <Chip className="proof-tag float-right" icon={<i className="fa-solid fa-file-lines font-size-12 color-proof-icon" />} label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxProof}</Typography>} name={proof.returnId} />
                            </Grid>
                          </Grid>
                        </Grid>
                      )
                    })}

                    {this.state.certs && this.state.certs.map((cert, index) => {
                      let size = cert !== null ? this.bytesToBestMagnitude(cert.documentSize) : 0
                      return (
                        <Grid container item md={12} key={"cert-" + index}>
                          <Grid container item md={12} className="pt-0 pb-0">
                            <Typography className="typography-generic bigweight link-hover" name={cert.returnId} onClick={this.downloadFeedbackFile}>{cert.documentFileName}</Typography>
                          </Grid>
                          <Grid container item md={12} className="pt-0 pb-0">
                            <Grid item md={8}>
                              <Typography className="typography-generic small"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(cert.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size}</Typography>
                            </Grid>
                            <Grid item md={4}>
                              <Chip className="cert-tag float-right" icon={<i className="fa-solid fa-certificate font-size-12 color-cert-icon" />} label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxCert}</Typography>} name={cert.returnId} />
                            </Grid>
                          </Grid>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>

          </DialogContent>
          {/* Waiting for service response. */}
          {this.state.isLoading &&
            <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
              <CircularProgress color="secondary" />
            </Backdrop>
          }

        </Dialog>

      </React.Fragment>
    )
  }
}

export default FeedbackShipmentSummary


// WEBPACK FOOTER //
// ./src/components/inbox/sections/FeedbackShipmentSummary.js